import { Route } from "@faire/web-api/Route";
import { props as netTermsRouteProps } from "@faire/web-api/routes/net-terms";
import { props as netTermsApplyRouteProps } from "@faire/web-api/routes/net-terms/apply";
import { props as netTermsIncreaseLimitRouteProps } from "@faire/web-api/routes/net-terms/increase-limit";
import { props as netTermsSuccessRouteProps } from "@faire/web-api/routes/net-terms/success";
import { Switch } from "@faire/web/ui/routing/Switch";
import React from "react";

import { isLoggedInRetailer } from "@faire/retailer/lib/isLoggedInRetailer";

import { LazyApplyForNetTerms } from "../net-terms/ApplyForNetTerms";
import { LazyIncreaseTermsLimit } from "../net-terms/IncreaseTermsLimit";
import { LazyTermsLimitApplicationSuccess } from "../net-terms/TermsLimitApplicationSuccess";

import { LazyNetTermsHub } from "./lazyIndex";

export const NetTermsHubRoutesExcludingOwfApplication: React.FC = () => (
  <Switch>
    {isLoggedInRetailer() ? (
      <Route
        {...netTermsSuccessRouteProps}
        component={LazyTermsLimitApplicationSuccess}
      />
    ) : null}
    {isLoggedInRetailer() ? (
      <Route
        {...netTermsIncreaseLimitRouteProps}
        component={LazyIncreaseTermsLimit}
      />
    ) : null}
    {isLoggedInRetailer() ? (
      <Route {...netTermsApplyRouteProps} component={LazyApplyForNetTerms} />
    ) : null}
    <Route {...netTermsRouteProps} component={LazyNetTermsHub} />
  </Switch>
);
